


import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import AuthPage from './pages/AuthPage';
import Dashboard from './pages/Dashboard';
import ProtectedRoute from './components/ProtectedRoute';
import HomePage from './pages/HomePage'; 
import Header from './components/Header';
import Footer from './components/Footer';
// import FormManagement from './pages/FormManagement';
import AboutUs from './pages/AboutUs';
// import HowItWorks from './pages/HowItWorks';
// import WhyAC from './pages/WhyAC';
import Cookie from './pages/Cookie';
import Terms from './pages/Terms';
import Policy from './pages/Policy';
// import VideoReviews from './pages/VideoReviews';
// import RomanceScam from './pages/RomanceScam';
// import InvoiceScam from './pages/InvoiceScam';
// import CryptoScam from './pages/CryptoScam';
// import SafeAccountScam from './pages/SafeAccountScam';
// import InvestmentScam from './pages/InvestmentScam';
// import JobTaskScam from './pages/JobTaskScam';
// import PurchaseScam from './pages/PurchaseScam';
// import UnauthorisedScam from './pages/UnauthorisedScam';
// import SkilledWorkerEmploymentVisas from './pages/SkilledWorkerEmploymentVisas';
// import StudyPermitsGraduatePathways from './pages/StudyPermitsGraduatePathways';
// import FamilyDependentVisas from './pages/FamilyDependentVisas';
// import PermanentResidenceCitizenship from './pages/PermanentResidenceCitizenship';
// import InvestorEntrepreneurVisas from './pages/InvestorEntrepreneurVisas';
// import VisitorShortStay from './pages/VisitorShortStay';
// import AppealsComplexCases from './pages/AppealsComplexCases';
// import UnitedStates from './pages/UnitedStates';
// import Canada from './pages/Canada';
// import UnitedKingdom from './pages/UnitedKingdom';
// import GermanyEU from './pages/GermanyEU';
// import Australia from './pages/Australia';
// import UAE from './pages/UAE';
import Contact from './pages/Contact';
import InvoicePayments from './pages/InvoicePayments';
import ManageInvoices from './pages/ManageInvoices';
import ResetPassword from './pages/ResetPassword';
import NotFound from './pages/NotFound';  // Import the NotFound page

const RootRoute = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <svg
            className="animate-spin h-12 w-12 text-[#202356] mx-auto mb-4"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return isAuthenticated ? <Navigate to="/dashboard" replace /> : <AuthPage />;
};

const AppContent = () => {
  const location = useLocation();
  const { isAuthenticated } = useAuth();
  const isAuthRoute = location.pathname === '/';
  const showHeaderFooter = !isAuthRoute && !isAuthenticated;

  return (
    <>
      {showHeaderFooter && <Header />}
      <Routes>
        <Route path="/" element={<RootRoute />} />
        
        {/* Protected Dashboard Route - renders based on user role */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        {/* <Route path="/start-claim" element={<StartClaim />} />  */}
        <Route path="/about" element={<AboutUs />} /> 
        {/* <Route path="/how-it-works" element={<HowItWorks />} />  */}
        {/* <Route path="/why-us" element={<WhyAC />} />  */}
        <Route path="/terms-of-service" element={<Terms />} /> 
        <Route path="/privacy-policy" element={<Policy />} /> 
        <Route path="/cookie-policy" element={<Cookie />} /> 
        {/* <Route path="/reviews" element={<VideoReviews />} />  */}
        {/* <Route path="/scams/romance" element={<RomanceScam />} />  */}
        {/* <Route path="/scams/invoice" element={<InvoiceScam />} />  */}
        {/* <Route path="/scams/investment" element={<InvestmentScam />} />  */}
        {/* <Route path="/scams/crypto" element={<CryptoScam />} />  */}
        {/* <Route path="/scams/safe" element={<SafeAccountScam />} />  */}
        {/* <Route path="/scams/purchase" element={<PurchaseScam />} />  */}
        {/* <Route path="/scams/job" element={<JobTaskScam />} />  */}
        {/* <Route path="/scams/unauthorised" element={<UnauthorisedScam />} />  */}
        {/* <Route path="/services/skilled-worker-employment" element={<SkilledWorkerEmploymentVisas />} /> */}
        {/* <Route path="/services/skilled-worker-employment-visas" element={<SkilledWorkerEmploymentVisas />} /> */}
        {/* <Route path="/services/study-permits-graduate-pathways" element={<StudyPermitsGraduatePathways />} /> */}
        {/* <Route path="/services/family-and-dependent-visas" element={<FamilyDependentVisas />} /> */}
        {/* <Route path="/services/permanent-residence-and-citizenship" element={<PermanentResidenceCitizenship />} /> */}
        {/* <Route path="/services/investor-and-entrepreneur-routes" element={<InvestorEntrepreneurVisas />} /> */}
        {/* <Route path="/services/visitor-and-short-stay" element={<VisitorShortStay />} /> */}
        {/* <Route path="/services/appeals-and-complex-cases" element={<AppealsComplexCases />} /> */}  
        {/* <Route path="/countries/united-states" element={<UnitedStates />} /> */}
        {/* <Route path="/countries/canada" element={<Canada />} /> */}
        {/* <Route path="/countries/united-kingdom" element={<UnitedKingdom />} /> */}
        {/* <Route path="/countries/germany-eu" element={<GermanyEU />} /> */}
        {/* <Route path="/countries/australia" element={<Australia />} /> */}
        {/* <Route path="/countries/uae" element={<UAE />} /> */}
        <Route path="/contact" element={<Contact />} />
        <Route path="/invoice/payments" element={<InvoicePayments />} />
        <Route path="/invoice/manage" element={<ManageInvoices />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        {/* <Route path="/forms/jndfe8939434ndfd" element={<FormManagement />} /> */}

        {/* Catch-all route for 404 pages */}
        <Route path="*" element={<NotFound />} />
      </Routes>
      {showHeaderFooter && <Footer />}
    </>
  );
};

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
};

export default App;
